import { Tab } from "../helper-classes/Tab";
import { ContractStatuses } from "../constants/contract-enums";
import { ProjectIcons, ProjectShowIcons } from "./icon-maps";
import { ProjectStatuses } from "../constants/enums";

export const projectsIndexTabs = [
  new Tab(
    "design",
    ProjectStatuses.DESIGN,
    ProjectIcons[ProjectStatuses.DESIGN],
    0
  ),
  new Tab(
    "active const",
    ProjectStatuses.ACTIVE,
    ProjectIcons[ProjectStatuses.ACTIVE],
    0
  ),
  new Tab(
    "warranty",
    ProjectStatuses.WARRANTY,
    ProjectIcons[ProjectStatuses.WARRANTY],
    0
  ),
  new Tab(
    "inactive",
    ProjectStatuses.INACTIVE,
    ProjectIcons[ProjectStatuses.INACTIVE],
    0
  )
];

export const crewSupervisorIndexTabs = projectsIndexTabs.slice(1, 3);

export const projectShowTabs = [
  new Tab(
    "active contracts",
    ContractStatuses.ACTIVE,
    ProjectShowIcons[ContractStatuses.ACTIVE],
    0
  ),
  new Tab(
    "warranty contracts",
    ContractStatuses.WARRANTY,
    ProjectShowIcons[ContractStatuses.WARRANTY],
    0
  ),
  new Tab(
    "closed contracts",
    ContractStatuses.CLOSED,
    ProjectShowIcons[ContractStatuses.CLOSED],
    0
  )
];
